import { useQuery } from "@tanstack/react-query";
import { journalsQueries } from "@entities/journal";
import type { components } from "@entities/journal";
import { useCoordinator } from "@shared/lib/hooks";

type Developer = "developer";
type TechnicalCustomer = "technicalCustomer";
type ProjectDocumentationContractor = "projectDocumentationContractor";
type BuildingContractor = "buildingContractor";
type DesignerSupervisions = "designerSupervisions";
type OtherDevelopers = "otherDevelopers";

export function useGetRepresentative<
  T extends
    | Developer
    | TechnicalCustomer
    | ProjectDocumentationContractor
    | BuildingContractor
    | DesignerSupervisions
    | OtherDevelopers,
>(type: T) {
  const { titleId } = useCoordinator();
  const { data, isLoading, isFetching } = useQuery(
    journalsQueries.getTitleJournal({ titleId }),
  );
  return {
    representative: data?.mainJournal?.titleJournal?.[
      type
    ] as T extends Developer
      ? components["schemas"]["TitleJournalDeveloper"]
      : T extends TechnicalCustomer
        ? components["schemas"]["TitleJournalTechnicalCustomer"]
        : T extends ProjectDocumentationContractor
          ? components["schemas"]["TitleJournalProjectDocumentationContractor"]
          : T extends BuildingContractor
            ? components["schemas"]["TitleJournalBuildingContractor"]
            : T extends DesignerSupervisions
              ? components["schemas"]["TitleJournalDesignerSupervision"][]
              : T extends OtherDevelopers
                ? components["schemas"]["TitleJournalOtherDeveloper"][]
                : unknown,
    isLoading,
    isFetching,
  };
}
